<sfx-header disableDividers>
    <div class="section-header" data-layout="row" data-layout-align="space-between center">
        <span translate>Calendar accounts</span>
        <button mat-button color="primary" track-id="connect-calendar" (click)="connectProvider()">
            <span translate>Connect calendar</span>
        </button>
    </div>
</sfx-header>

<sfx-section disableContentPadding>

    <p *ngIf="calendarAccountsLoaded && calendarAccountsSubject$.value.calendarAccounts.length === 0" class="section-empty-text" translate>No calendars connected yet!</p>

    <ng-container *ngFor="let calendarAccount of calendarAccounts$ | async">

        <mat-card appearance="outlined">
            <mat-card-header>
                <img [src]="calendarAccount.avatar" mat-card-avatar/>
                <mat-card-title>{{ calendarAccount.name }}</mat-card-title>
                <mat-card-subtitle>{{ calendarAccount.profile_name }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <mat-card-actions *ngFor="let calendar of calendarAccount.calendars">
                    <mat-slide-toggle color="primary"
                                      [(ngModel)]="calendar.active"
                                      (change)="changeActiveState(calendarAccount, calendar)"
                    >
                        <div class="accent">
                            {{ calendar.name }}
                        </div>
                    </mat-slide-toggle>
                </mat-card-actions>
            </mat-card-content>
            <mat-card-actions>
                <button mat-button
                        track-id="disconnect-calendar" (click)="disconnect(calendarAccount)" [disabled]="calendarAccount.disconnecting"
                        >
                    <span translate>Disconnect</span>
                </button>
            </mat-card-actions>
        </mat-card>

    </ng-container>

</sfx-section>
